/**
 * @generated SignedSource<<c1fe2a202379a719e975293c576df98f>>
 * @relayHash 7f32c0bf3953ad5ef40b48b239667746
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7f32c0bf3953ad5ef40b48b239667746

import { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type ExamMessagesNewVersionAnnouncementSubscription$variables = {
  examVersionId: string;
};
export type ExamMessagesNewVersionAnnouncementSubscription$data = {
  readonly versionAnnouncementReceived: {
    readonly versionAnnouncement: {
      readonly body: string;
      readonly createdAt: string;
      readonly id: string;
    };
    readonly versionAnnouncementsEdge: {
      readonly node: {
        readonly id: string;
      } | null;
    };
  };
};
export type ExamMessagesNewVersionAnnouncementSubscription = {
  response: ExamMessagesNewVersionAnnouncementSubscription$data;
  variables: ExamMessagesNewVersionAnnouncementSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "examVersionId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "examVersionId",
        "variableName": "examVersionId"
      }
    ],
    "concreteType": "VersionAnnouncementReceivedPayload",
    "kind": "LinkedField",
    "name": "versionAnnouncementReceived",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "VersionAnnouncement",
        "kind": "LinkedField",
        "name": "versionAnnouncement",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "body",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "VersionAnnouncementEdge",
        "kind": "LinkedField",
        "name": "versionAnnouncementsEdge",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "VersionAnnouncement",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ExamMessagesNewVersionAnnouncementSubscription",
    "selections": (v2/*: any*/),
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExamMessagesNewVersionAnnouncementSubscription",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "7f32c0bf3953ad5ef40b48b239667746",
    "metadata": {},
    "name": "ExamMessagesNewVersionAnnouncementSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "a897fa3f43b53188af93e7d6c869cfa3";

export default node;
